import { z } from 'zod';
import { formResponseSchema, issueLineRequestSchema } from './issuance.js';
/**
 * Rotation / swap (REQUIREMENTS §2.5): cleaning, repair, or replacement, in
 * either order — the old item handed in first, or the new one received first.
 *
 * Both halves share a `rotationId` so the pair reads as one event on the
 * ledger and on the soldier's page. There is no rotation document: the id
 * lives on the two assignments, the replacement form, and the ledger entries.
 *
 *  - rotation-out: the old assignment goes `in_rotation` and stays on the
 *    soldier's account (it is still theirs to answer for) until its
 *    disposition is recorded with the ordinary return or write-off.
 *  - rotation-in: the replacement is issued on a new form, pending the
 *    soldier's own signature like any other issue. Called on an `active`
 *    assignment it is the new-first order; on an `in_rotation` one it is the
 *    second half of old-first.
 *
 * The rotation is complete when the replacement is signed and the old item
 * is returned or written off — a derived state, never a stored one.
 */
export const rotationReasonSchema = z.enum(['cleaning', 'repair', 'replacement']);
/** POST /api/assignments/:id/rotation-out */
export const rotationOutRequestSchema = z.object({
    reason: rotationReasonSchema,
    notes: z.string().trim().max(500).nullable().default(null),
});
/**
 * POST /api/assignments/:id/rotation-in — the replacement. Always the same
 * catalog item as the old assignment: a swap for something else is a return
 * and a fresh issue, which the ledger should say plainly.
 */
export const rotationInRequestSchema = z.object({
    replacement: issueLineRequestSchema.omit({ catalogItemId: true }),
});
export const rotationInResponseSchema = formResponseSchema;
//# sourceMappingURL=rotation.js.map